import { API_URL } from "../services/api";

export const downloadFile = (file, contextPath = 'ap1') => {
  // If file is already a Blob/File object

  if (file instanceof Blob) {
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  // If file is a URL (for server files)
  else if (typeof file.filePath === 'string') {
    const a = document.createElement('a');
    a.href = API_URL + `/app/${contextPath}/agent/downloadFile?filePath=` +  file.filePath;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  else if (typeof file.url === 'string') {
    const a = document.createElement('a');
    a.href = file.url;
    a.target = '_blank';
    a.download = file.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}; 